<ng-template>
  <div class="select-trigger">
    <div *ngIf="!hasValue" class="placeholder">{{ placeholder }}</div>
    <ng-content></ng-content>
  </div>
</ng-template>
